import React, { FC, useCallback } from 'react';
import { openCategoryModal } from 'data/cacheHelpers/menu';
import Placeholder from 'components/Placeholders/MenuManagement';
import { Loader, TitleLoader } from 'components/Loaders/MenuManagementItem';
import Categories from 'components/Categories';
import { Container, LoaderContainer, Button } from './styles';
import { Props } from './types';

const Items: FC<Props> = ({ isLoading, brandId, categories, isProcessing }) => {
  const openNewCategoryModal = useCallback(
    () => openCategoryModal(brandId),
    [brandId],
  );

  if (isLoading) {
    return (
      <>
        <Button size="big" type="button" disabled>
          Add category
        </Button>
        <LoaderContainer>
          <TitleLoader />
          <Loader opacity={1} />
          <Loader opacity={0.75} />
          <Loader opacity={0.5} />
          <Loader opacity={0.25} />
          <Loader opacity={0} />
        </LoaderContainer>
      </>
    );
  }

  return (
    <Container>
      {categories > 0 ? (
        <>
          <Button
            size="big"
            type="button"
            onClick={openNewCategoryModal}
            disabled={isProcessing}
          >
            Add category
          </Button>
          <Categories brandId={brandId} isProcessing={isProcessing} />
        </>
      ) : (
        <Placeholder
          message={`You don't have any menu category yet`}
          buttonCaption="Add category"
          disabled={isProcessing}
          onClick={openNewCategoryModal}
        />
      )}
    </Container>
  );
};

export default Items;
